export const RADIO_PARTS = ['container', 'control', 'label'] as const;
